import React from "react";
import Login from "./login";
import Register from "./Register";
import SessionSetting from "./SessionSetting";
import SchoolRegistrationSuccess from "./SchoolRegistrationSuccess";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import AdminMain from "./Admin/AdminMain";
import StaffPrivilege from "./Admin/StaffPrivilege";
import "@fortawesome/fontawesome-free/css/all.min.css";

require("dotenv").config();

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/" exact component={Login} />
        <Route path="/Login" exact component={Login} />
        {/* Created By Cursor — CRM App Access auto-login entry */}
        <Route path="/mypage/login" exact component={Login} />
        <Route path="/Register" exact component={Register} />
        <Route path="/SessionSetting" exact component={SessionSetting} />
        <Route
          path="/SchoolRegistrationSuccess"
          exact
          component={SchoolRegistrationSuccess}
        />
        <Route path="/AdminMain" component={AdminMain} />
      </Switch>
    </Router>
  );
}

export default App;
